export enum NamedBullJobTypes {
  VALIDATE_MEMBER = 'ValidateImportedMembersListJob',
  VALIDATE_USER = 'ValidateUserInviteListJob'
}
